module.exports = __webpack_public_path__ + "img/fhconnect.248d2564.png";